import React from 'react';
import { Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { DesktopNavigationProps } from '../../types/navigation.types';

export const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ items }) => (
    <Box sx={{ display: 'flex', gap: 2 }}>
        {items.map((item) => (
            <Button
                key={item.label}
                color="inherit"
                component={RouterLink}
                to={item.path}
            >
                {item.label}
            </Button>
        ))}
    </Box>
); 